





























































































































































































import store, { Dataset, Enterprise, GrowthRateSources, MonthlyPasture, PastureKeys, Stock } from "../../store";
// import moment, { max } from "moment";
import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import { inv, multiply, mod } from "mathjs";

import AvailableDates, {
  MidpointDates,
  StartDates,
  PeriodLengths
} from "@/common/dates";
import { colors } from "@/common/colors";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Breeds, EnterpriseKeys } from '@/common/Formulas/JSON';
import { getShortBreedName } from '@/common/Formulas/Shared';
import LOCATIONS from '@/data/locations';
import { cleanDate } from "@/filters/filters";

interface Pasture {
  ID: number;
  LocationID: number;
  Pasture: string;
  Weight: number;
  Legume: number;
  Months: number[];
}

const PASTURES: Pasture[] = require("@/data/pastures.json");
const DMDI = require("@/data/dmdi.json");
const DWN = require("@/data/dwn.json");

dayjs.extend(dayOfYear);

const CalculationsProps = Vue.extend({
  props: {
    calcEnterprise: {
      type: String,
      required: true,
    },
    calcVisible: {
      type: Boolean,
      default: true,
      required: true,
    },
    radioVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
});

@Component
export default class Calculations extends CalculationsProps {
  tab = "tab-0";
  enterprise = this.calcEnterprise as EnterpriseKeys;
  minMatingIntervalPeriods = 18;

  created() {
    // console.log("store", store.state);
    this.onEnterpriseChanged();
  }

  // Order is important
  @Watch("enterprise")
  onEnterpriseChanged() {
    const timer = "Livestock calculations (" + this.calcEnterprise + ")"
    // console.time(timer)

    // Pasture
    this.growth();
    this.weighting();
    this.dmdi();
    // Livestock
    this.conceptionRate();
    this.averageDOYofBirth();
    this.startAges();
    this.agesAtMidpoint();
    this.animalSRW();
    this.pastureDwn();
    this.defaultWeightForAge();
    this.maxNormalWeight();
    this.defaultDw();
    this.liveWeight();
    this.sucklingJoinPeriod();
    this.headOfStock();
    this.weanedData();
    this.updateLivestockValues();
    this.updateState(); // Update state 1

    // console.timeEnd(timer)
  }

  // Commonly used calcuations
  common: {
    periods: any;
    growth: any;
    weighting: any;
    dmdi: any;
    conceptionRate: any;
    averageDOYofBirth: any;
    startAges: any;
    agesAtMidpoint: any;
    animalSRW: any;
    pastureDwn: any;
    defaultWeightForAge: any;
    maxNormalWeight: any;
    defaultDw: any;
    liveWeight: any;
    sucklingJoinPeriod: {
      mature: any;
      young: any;
    };
    headOfStock: any;
    weanedData: any;
  } = {
    periods: null,
    growth: null,
    weighting: null,
    dmdi: null,
    conceptionRate: null,
    averageDOYofBirth: null,
    startAges: null,
    agesAtMidpoint: null,
    animalSRW: null,
    pastureDwn: null,
    defaultWeightForAge: null,
    maxNormalWeight: null,
    defaultDw: null,
    liveWeight: null,
    sucklingJoinPeriod: {
      mature: null,
      young: null,
    },
    headOfStock: null,
    weanedData: null
  };

  // Breed parameters
  get param() {
    const selectedBreed = getShortBreedName(this.getEnterprise.livestock.breed);
    return {
      TWINSA: Breeds.parameters["Twins:a"][selectedBreed],
      TWINSB: Breeds.parameters["Twins:b"][selectedBreed],
      DLF1: Breeds.parameters["DLF(1)"][selectedBreed],
      DLF2: Breeds.parameters["DLF(2)"][selectedBreed],
      BWN: Breeds.parameters["BW:N"][selectedBreed],
      CN1: Breeds.parameters["C(N,1)"][selectedBreed],
      CN2: 0.27,
      CN3: 0.4,
      CM2: Breeds.parameters["C(M,2)"][selectedBreed],
      CM6: Breeds.parameters["C(M,6)"][selectedBreed],
      CP1: Breeds.parameters["C(P,1)"][selectedBreed],
      CP2: Breeds.parameters["C(P,2)"][selectedBreed],
      CP3: Breeds.parameters["C(P,3)"][selectedBreed],
      CP5: Breeds.parameters["C(P,5)"][selectedBreed],
      CP6: Breeds.parameters["C(P,6)"][selectedBreed],
      CP7: Breeds.parameters["C(P,7)"][selectedBreed],
      CP8: Breeds.parameters["C(P,8)"][selectedBreed],
      CP9: Breeds.parameters["C(P,9)"][selectedBreed],
      CP10: Breeds.parameters["C(P,10)"][selectedBreed],
      CP141: Breeds.parameters["C(P,14,1)"][selectedBreed],
      CP142: Breeds.parameters["C(P,14,2)"][selectedBreed],
      CL01: Breeds.parameters["C(L,0,1)"][selectedBreed],
      CL02: Breeds.parameters["C(L,0,2)"][selectedBreed],
      CL1: Breeds.parameters["C(L,1)"][selectedBreed],
      CL2: Breeds.parameters["C(L,2)"][selectedBreed],
      CL3: Breeds.parameters["C(L,3)"][selectedBreed],
      CL6: Breeds.parameters["C(L,6)"][selectedBreed],
      CL12: Breeds.parameters["C(L,12)"][selectedBreed],
      CL13: Breeds.parameters["C(L,13)"][selectedBreed],
      CL14: Breeds.parameters["C(L,14)"][selectedBreed],
      CL21: Breeds.parameters["C(L,21)"][selectedBreed],
      CL22: Breeds.parameters["C(L,22)"][selectedBreed],
      CWA: Breeds.parameters["C(W,A)"][selectedBreed],
      CW6: Breeds.parameters["C(W,6)"][selectedBreed],
      CWB: Breeds.parameters["C(W,B)"][selectedBreed],
      EVGMAX: Breeds.parameters["EVG(max)"][selectedBreed],
      EVGRANGE: Breeds.parameters["EVG(range)"][selectedBreed],
      SRW: Breeds.parameters["SRW"][selectedBreed],
    };
  }

  // N(max) - curvature
  get curvature() {
    return this.param.CN1 / Math.pow(this.livestockWeight, this.param.CN2);
  }

  // Cattle or Sheep
  get getEnterprise() {
    return store.state[this.enterprise] as Enterprise;
  }

  // Stocks
  get stocks() {
    return this.getEnterprise.stock;
  }

  // Livestock weight
  get livestockWeight() {
    return this.getEnterprise.livestock.weight;
  }

  // Gestation length
  get gestationLength() {
    return this.enterprise === "cattle" ? 285 : 150;
  }

  // Gestation periods
  get gestationPeriods() {
    return this.enterprise === "cattle" ? 19 : 10;
  }

  // Periods (half-months) from start date
  get periods() {
    let periodArr: number[] = [];
    for (let i = 0; i < 24; i++) {
      if (i === 0) {
        periodArr.push(
          StartDates.indexOf(
            dayjs(store.state.pasture!.simulation.date).format("D MMM")
          ) + 1
        );
      } else {
        periodArr.push(mod(1 + periodArr[i - 1], 24));
      }
    }
    this.common.periods = periodArr
    return periodArr;
  }

  // Months from start date
  get months() {
    let months: number[] = [];
    for (let period = 0; period < 24; period++) {
      if (period % 2 === 0) {
        months.push(
          dayjs(cleanDate(StartDates[mod(this.periods[period] - 1, 24)], 'D MMM'), 'D MMM').month()
        );
      }
    }
    return months;
  }

  // Pasture Types
  get types() {
    let types: Pasture[] = [];
    let startIndex = PASTURES.map((e: any) => e.LocationID).indexOf(
      store.state.pasture!.simulation.location
    );
    let endIndex = PASTURES.map((e: any) => e.LocationID).indexOf(
      store.state.pasture!.simulation.location + 1
    );
    for (let i = startIndex; i < endIndex; i++) {
      types[i - startIndex] = PASTURES[i];
    }
    store.state.types = types;
    return types;
  }

  // Midpoint DOY
  get midpointDOY() {
    let midpoints: number[] = [];
    for (let i = 0; i < 24; i++) {
      midpoints.push(
        dayjs(cleanDate(MidpointDates[mod(this.periods[i] - 1, 24)], 'D MMM'), 'D MMM').dayOfYear() + 1
      );
    }
    return midpoints;
  }

  // Daylength
  get daylength() {
    const location = LOCATIONS.filter(
      (location: any) => location.ID === store.state.pasture!.simulation.location
    )[0];
    const latitude: number = location.Latitude;
    const midpoints = this.midpointDOY;
    const dlAmplitude =
      (24 / Math.PI) * Math.acos(0.434 * Math.tan((Math.PI * latitude) / 180)) -
      12;

    let daylengths: any[] = [];
    for (let i = 0; i < 24; i++) {
      daylengths.push(
        12.15 +
          dlAmplitude * Math.cos((2 * Math.PI * (midpoints[i] + 10)) / 365)
      );
    }
    return daylengths;
  }

  // Produces Offspring
  get producesOffspring() {
    return ['Cows (>3 years)', 'Cows (2-3 years)', 'Heifers (1-2 years)', 'Ewes (>2 years)', 'Ewes (1-2 years)']
  }

  // Mothers
  get mothers() {
    const cattleMothers = ["Cows (>3 years)", "Cows (2-3 years)"];
    const sheepMothers = ["Ewes (>2 years)"];
    // Join 1-2 year heifers / ewes
    if (this.enterprise === 'cattle') {
      if (this.getEnterprise.livestock.joinOption) {
        cattleMothers.push("Heifers (1-2 years)")
      }
    } else {
      if (this.getEnterprise.livestock.joinOption) {
        sheepMothers.push("Ewes (1-2 years)")
      }
    }
    const mothers = this.enterprise === "cattle" ? cattleMothers : sheepMothers;
    return mothers
  }

  // ------------------------------------------------------------
  // ----------------------- HELPERS ----------------------------
  // ------------------------------------------------------------

  // Remove reactivity from data source
  cleanSource<T>(source: T): T {
    return (JSON.parse(JSON.stringify(source)) as any) as T;
  }

  trim (value:number) {
    return value // raw
    // return parseFloat(value.toFixed(5)); // trimmed
  }

  updateState() {
    this.calcEnterprise === 'cattle'
    ? store.state.calculations.cattle = this.common
    : store.state.calculations.sheep = this.common
    this.calcEnterprise === 'cattle'
    ? store.state.cattle.calculations = this.common
    : store.state.sheep.calculations = this.common
    store.dispatch("updateCattle", store.state.cattle);
    store.dispatch("updateSheep", store.state.sheep);
    store.dispatch("updateCalculations", { cattle: store.state.calculations.cattle, sheep: store.state.calculations.sheep });
  }

  // ------------------------------------------------------------
  // --------------------- CALCULATIONS -------------------------
  // ------------------------------------------------------------

  // Growth rate
  growth() {
    let areaGrowths: any[] = [];
    let totalAreaGrowths: any[] = [];
    let growthRates: number[] = [];
    
    if (this.$store.state.pasture.simulation.growthRateSource === 'Add Pasture Types') {
      let pastureKeys = Object.keys(store.state.pasture!.monthlyPasture[0]).filter(
        (e: any) => e.substr(0, 1) === "p"
      );
      // Area x Growth (Pasture)
      for (let i = 0; i < pastureKeys.length; i++) {
        let arr: any[] = [];
        store.state.pasture!.monthlyPasture.forEach((month: any) => {
          arr.push(
            Math.round(month[pastureKeys[i]].area * month[pastureKeys[i]].growth)
          );
        });
        areaGrowths.push(arr);
      }
      // Area x Growth (Monthly Total)
      for (let j = 1; j < areaGrowths.length; j++) {
        totalAreaGrowths = areaGrowths[0].map((num: any, idx: any) => {
          for (let k = 1; k < pastureKeys.length; k++) {
            return num + areaGrowths[k][idx];
          }
        });
      }
    }

    // Average Growth Rate
    const vm = this
    function getAverageGrowth(month: MonthlyPasture) {
      const growthSource = vm.$store.state.pasture.simulation.growthRateSource
      const index = vm.$store.state.pasture.monthlyPasture.indexOf(month)
      let avgG = 0
      // Combined pasture growths rates
      if (growthSource === 'Add Pasture Types') {
        // ((growth1 * area1) + (growth2 * area2) + ...) / total area
        let pastureColumns:PastureKeys[] = Object.keys(month).filter((e: any) => e.substr(0, 1) === 'p') as PastureKeys[]
        let totalArea:number = 0
        pastureColumns.forEach((p:PastureKeys) => {
            if (month[p] !== undefined) {
                if (month[p].pasture.type !== null) {
                    totalArea += month[p].area
                    avgG += month[p].growth * month[p].area
                }
            }
        })
        avgG = avgG / totalArea
      // Standard growth rates
      } else if (growthSource === 'Standard Average Values') {
        avgG = LOCATIONS[vm.$store.state.pasture.simulation.location - 1].StdPastureGrowth[index]
      } else {
        avgG = vm.$store.state.pasture.monthlyPasture[index].avgGrowth
      }
      if (isNaN(avgG)) {
        return 0
      }
      return avgG
    }
    this.$store.state.pasture.monthlyPasture.forEach((month:MonthlyPasture) => {
      growthRates.push(this.trim(getAverageGrowth(month)))
    });

    let growths = {
      areaGrowths: areaGrowths,
      totalAreaGrowths: totalAreaGrowths,
      growthRates: growthRates
    }

    // TESTS
    // console.log(growths)

    this.common.growth = growths
    return growths
  }

  // Weightings needed to calculate the dmdis (Input Worksheet)
  weighting() {
    const growth = this.common.growth

    // Weightings
    let weightings: any[] = [];
    for (let p = 0; p < growth.areaGrowths.length; p++) {
      weightings.push(
        growth.totalAreaGrowths.map((tag: any, month: any) => {
          return (
            Math.round((growth.areaGrowths[p][month] / tag) * 100) / 100 ||
            1 / (growth.areaGrowths.length * 100)
          );
        })
      );
    }

    // TESTS
    // console.log("Weightings", weightings);

    this.common.weighting = weightings;
    return weightings;
  }

  // Array of average dmdi for each month (Input Worksheet)
  dmdi (this:any) {
    const growth = this.common.growth
    const weighting = this.common.weighting
    const growthSource:GrowthRateSources = this.$store.state.pasture.simulation.growthRateSource
    let dmdis:any[] = Array(24).fill(0)

    if (growthSource === 'Add Pasture Types') {
      // Get Fortnightly DMDIs for each selected pasture
      let dmdiFortnightly:any[] = []
      for (let i = 0; i < store.state.pasture!.simulation.pastures.length; i++) {
        let index = this.types.map((e:any) => e.Pasture).indexOf(store.state.pasture!.simulation.pastures[i].type)
        let pastures = PASTURES.filter((e:any) => e.LocationID === this.types[index].LocationID)
        let activePasture = pastures[pastures.map((e:any) => e.Pasture).indexOf(this.types[index].Pasture)]
        let activePastureDMDIFortnightly = DMDI[this.enterprise][activePasture.ID - 1]
        activePastureDMDIFortnightly = Object.values(activePastureDMDIFortnightly)

        let activePastureDMDI:any[] = []
        for (let j = 0; j < activePastureDMDIFortnightly.length; j++) {
          activePastureDMDI.push((activePastureDMDIFortnightly[j]))
        }
        dmdiFortnightly.push(activePastureDMDI)
      }

      // Multiply pasture dmdi by corresponding weighting
      let results:any[] = []
      dmdiFortnightly.forEach((pasture:any, pIx:number) => {
        results.push([])
        pasture.map((dmdi:any, dIx:number) => {
          results[pIx].push(pasture[dIx] * weighting[pIx][Math.floor((dIx) / 2)])
        })
      })

      // Get combined pasture average dmdi
      results.forEach((pasture:any, ix:number) => {
        for (let i = 0; i < pasture.length; i++) {
          dmdis[mod(this.periods[i] - 1, 24)] += pasture[mod(this.periods[i] - 1, 24)]
        }
      })
    } else {
      // Get standard / user selected dmdi
      let count = 0
      this.$store.state.pasture.monthlyPasture.forEach((pasture:any, pix:number) => {
        for (let i = 1; i <= 2; i++) {
          dmdis[count] = (pasture.avgQuality + 2) / 17
          count += 1
        }
      });
    }

    // Final Enterprise-Specific DMDI Values
    let finalDmdis = dmdis.map((dmdi, period) => {
      if (growthSource === 'User-supplied Average Values' && this.$store.state.pasture.simulation.enterprise === 'Cattle & Sheep') {
        let tabularDmdiCattle = LOCATIONS[this.$store.state.pasture.simulation.location - 1].StdDmdiCattle
        let tabularDmdiSheep = LOCATIONS[this.$store.state.pasture.simulation.location - 1].StdDmdiSheep
        return dmdi + 0.5 * (tabularDmdiCattle[period] - tabularDmdiSheep[period])
      } else if (growthSource === 'Standard Average Values') {
        return (
          this.enterprise === 'cattle'
          ? LOCATIONS[this.$store.state.pasture.simulation.location - 1]['StdDmdiCattle'][period]
          : LOCATIONS[this.$store.state.pasture.simulation.location - 1]['StdDmdiSheep'][period]
        )
      } else {
        return dmdi
      }
    })
    
    // Include supplement values
    let dmdisWithSupplement = Array(24).fill(0)
    for (let period = 1; period <= 24; period++) {
      let dmdi = finalDmdis[period - 1]
      let month = Math.max(1, Math.ceil(period / 2)) - 1
      let growthRate = growth.growthRates[month]
      let supplementAmount = store.state.pasture!.monthlyPasture[month].supplement.amount
      let supplementDmdi = parseFloat(supplementAmount.toString()) > 0 ? store.state.pasture!.monthlyPasture[month].supplement.quality / 16 : dmdi
      dmdisWithSupplement[this.periods.indexOf(mod(period, 24))] = ((dmdi * growthRate + supplementAmount * supplementDmdi) / (growthRate + supplementAmount))
      dmdisWithSupplement = dmdisWithSupplement.map((dws:number) => { return isNaN(dws) ? 0 : this.trim(dws) })
    }

    // TESTS
    // console.log('DMDIs Fortnightly', dmdiFortnightly)
    // console.log('Weightings', weighting)
    // console.log('Results', results)
    // console.log('DMDIs - ' + this.enterprise, finalDmdis)
    // console.log('DMDIs with Supplement - ' + this.enterprise, dmdisWithSupplement)

    this.common.dmdi = dmdisWithSupplement
    return dmdisWithSupplement
  }

  // Starting conception rate - Reference CR (Mating Worksheet)
  referenceCR(joiningPeriod: 1 | 2) {
    const jp = this.getEnterprise.livestock.joinPeriods[joiningPeriod - 1];

    let toDatePeriod = StartDates.indexOf(dayjs(jp.toDate).format("D MMM"));
    let fromDatePeriod = StartDates.indexOf(dayjs(jp.fromDate).format("D MMM"));
    let lengthOfJoining = mod(toDatePeriod - fromDatePeriod, 24);

    let referenceCR =
      1 -
      Math.pow(1 - Math.min(jp.expectation, 0.999), 1 / lengthOfJoining) *
        Math.min(1, this.minMatingIntervalPeriods / lengthOfJoining);

    // TESTS
    // console.log('Length of joining', lengthOfJoining)
    // console.log('Reference CR', referenceCR)

    return referenceCR;
  }

  // Estimated conception rates x period: returns for (jp1, jp2 and total)
  conceptionRate() {
    let overallWeaningRate: number;
    let CR: number;
    let lambsConcieved = { single: new Array(24).fill(0), twins: new Array(24).fill(0), total: new Array(24).fill(0) };
    let survivingRates = { jp1: new Array(24).fill(0), jp2: new Array(24).fill(0) };
    let survivingTotals = { single: new Array(24).fill(0), twins: new Array(24).fill(0) };
    const mortality = {
      singles: 0.1,
      twins: 0.25
    };
    const vm = this;
    function getConceptionRateForJoiningPeriod(
      referenceCR: Function,
      jpNum: number
    ) {
      let FR: any[] = [];
      let numConceived: any[] = [];

      for (let iteration = 0; iteration < 4; iteration++) {
        const jp = store.state[vm.enterprise].livestock.joinPeriods[jpNum];
        let toDatePeriod = StartDates.indexOf(dayjs(jp.toDate).format("D MMM"));
        let fromDatePeriod = StartDates.indexOf(dayjs(jp.fromDate).format("D MMM"));
        let lengthOfJoining = mod(toDatePeriod - fromDatePeriod, 24);
        let numWeaned: any[] = [];

        // Initial Iteration
        if (iteration === 0) {
          CR = referenceCR(jpNum + 1);
          let twinningRate = Math.max(
            0,
            Math.min(
              1,
              vm.param.TWINSA + vm.param.TWINSB * CR * ((24 * 17) / 365)
            )
          );
          CR = vm.enterprise === "sheep" ? (CR = CR / (1 + twinningRate)) : CR;
        } else {
          CR = (CR * jp.expectation) / overallWeaningRate;
        }
        // console.log('Reference CR', CR)

        // MATRIX (Mating)
        let matrix: any[] = [];
        // P(>=1)
        let periods: any[] = new Array(24);
        for (let k = 0; k < 24; k++) {
          let row: any[] = new Array(24);
          for (let j = 0; j < 24; j++) {
            row[j] =
              j === k
                ? 1
                : 24 + ((k - j) % 24) < vm.minMatingIntervalPeriods
                ? CR
                : 0;
            if (k < lengthOfJoining) {
              periods[k] = CR;
              if (j < k) {
                row[j] = CR;
              }
            } else {
              row[j] = j === k ? 1 : 0;
            }
          }
          row = Array.from(row, (item) => item || 0);
          matrix.push(row);
        }
        periods = Array.from(periods, (item) => item || 0);
        // console.log('Matrix', matrix)
        // console.log('P(>=1)', periods)
        // console.log(multiply(inv(matrix), p))

        // TW
        let tw =
          vm.enterprise === "sheep"
            ? Math.max(
                0,
                Math.min(1, vm.param.TWINSA + vm.param.TWINSB * periods[0])
              )
            : 0;
        // ('TW', TW)

        // FR
        FR = multiply(inv(matrix), periods);
        for (let i = 0; i < (dayjs(jp.fromDate).month() * 2); i++) {
          FR.splice(0, 0, FR.pop());
        }
        // console.log('FR', FR)

        // # Conceived
        numConceived = FR.map(fr => fr * (1 + tw))
        // console.log('# Convceived', numConceived)

        // # Weaned, overallWeaningRate
        if (vm.enterprise === "cattle") {
          overallWeaningRate = numConceived.reduce(
            (prev: number, cur: number) => prev + cur
          );
        } else {
          for (let i = 0; i < 24; i++) {
            numWeaned[i] =
              FR[i] *
              ((1 - mortality.singles) * (1 - tw) +
                2 * tw * (1 - mortality.twins));
          }
          overallWeaningRate = numWeaned.reduce(
            (prev: number, cur: number) => prev + cur
          );
        }
        // console.log('# Weaned', numWeaned)
        // console.log('Overall Weaning Rate', overallWeaningRate)

        // Estimated Conception Rates x Period
        // Cattle (1) | Sheep (1)
        const percentage = parseFloat(jp.percentage.toString());
        let conceptionRatesPerPeriod = FR.map((c: number) => {
          if (vm.enterprise === "cattle") {
            return c * (percentage / 100)
          }
          if (vm.enterprise === "sheep") {
            return c * (percentage / 100) * (1 - tw)
          }
        });
        // console.log('Estimated Conception Rates x Period', conceptionRatesPerPeriod)

        if (iteration === 3) {
          if (vm.enterprise === "sheep") {
            let sheep1 = conceptionRatesPerPeriod
            let sheep2 = FR.map((c: number) => c * (percentage / 100) * tw)

            // console.log('sheep (1)', sheep1)
            // console.log('sheep (2)', sheep2)

            // Lambs Conceived

            lambsConcieved.single = lambsConcieved.single.map((lcs: any, ix: number) => {
              return lcs + sheep1[ix]
            })
            lambsConcieved.twins = lambsConcieved.twins.map((lct: any, ix: number) => {
              return lct + sheep2[ix]
            })
            lambsConcieved.total = lambsConcieved.single.map((lcs: any, ix: number) => {
              return lcs + 2 * lambsConcieved.twins[ix]
            })

            // Estimated (Surviving) Lambing / Calving Rates x Period

            sheep1 = sheep1.map((s:any) => s * (1 - mortality.singles))
            sheep2 = sheep2.map((s:any) => s * (1 - mortality.twins))

            // console.log('sheep (1)', sheep1)
            // console.log('sheep (2)', sheep2)

            survivingTotals.single = survivingTotals.single.map((st: any, ix: number) => {
              return st + sheep1[ix]
            })
            survivingTotals.twins = survivingTotals.twins.map((st: any, ix: number) => {
              return st + sheep2[ix]
            })

            if (jpNum === 0) {
              survivingRates.jp1 = survivingRates.jp1.map((sr: any, ix: number) => {
                return sr + sheep1[ix] + 2 * sheep2[ix]
              })
            } else {
              survivingRates.jp2 = survivingRates.jp2.map((sr: any, ix: number) => {
                return sr + sheep1[ix] + 2 * sheep2[ix]
              })
            }
          }

          return conceptionRatesPerPeriod;
        }
      }
    }

    let CRJP1: any = getConceptionRateForJoiningPeriod(this.referenceCR, 0);
    let CRJP2: any = getConceptionRateForJoiningPeriod(this.referenceCR, 1);

    // Calves Concieved
    let calvesConceived = CRJP1.map((cr: number, index: number) => cr + CRJP2[index]);

    let CRTOTAL = (vm.enterprise === "cattle") ? calvesConceived : lambsConcieved.total

    let conceptionRate = {
      lambs: {
        survivingTotals: survivingTotals,
        survivingRates: survivingRates
      },
      jp1: CRJP1.map((v:number) => this.trim(v)),
      jp2: CRJP2.map((v:number) => this.trim(v)),
      total: CRTOTAL.map((v:number) => this.trim(v)),
    };

    // TESTS
    // console.log('Conception Rate', conceptionRate)

    this.common.conceptionRate = conceptionRate;
    return conceptionRate;
  }

  // Average day of year of birth (0-365)
  averageDOYofBirth() {
    const startingDOY = dayjs(store.state.pasture!.simulation.date).dayOfYear() + 1;
    let ageNowArr: number[] = [];
    let conceivedArr: any[] = this.cleanSource(
      this.common.conceptionRate.total
    );
    
    for (let i = 0; i < 24; i++) {
      let periodMidpointDOY:number = dayjs(MidpointDates[i]).dayOfYear();
      let ageNow = startingDOY - periodMidpointDOY - this.gestationLength + 365;
      ageNowArr.push(ageNow);
    }
    ageNowArr = ageNowArr.map((an, an_ix) => {
      if (conceivedArr[an_ix] > 0 && conceivedArr[mod(an_ix - 1, 24)]) {
        return (
          ageNowArr[mod(an_ix - 1, 24)] -
          (dayjs(MidpointDates[an_ix]).dayOfYear() -
          (dayjs(MidpointDates[mod(an_ix - 1, 24)]).dayOfYear() - (an_ix === 0 ? 365 : 0)))
        )
      } else {
        return an
      }
    })

    let averageAgeNow = 0;
    let conceivedXAgeNow = conceivedArr.map((c: number, index: number) => {
      return c * ageNowArr[index]
    });
    if (conceivedArr.reduce((a, b) => a + b, 0) === 0) {
      averageAgeNow = ageNowArr[this.periods[0]]
    } else {
      averageAgeNow = (
        1 + mod((conceivedXAgeNow.reduce((a, b) => a + b, 0) / conceivedArr.reduce((a, b) => a + b, 0) - 1), 365)
      );
    }

    let averageDOYofBirth = mod(startingDOY - averageAgeNow, 365) || 0;

    // TESTS
    // console.log((this.enterprise === 'cattle' ? 'Calves' : 'Lambs') + ' conceived', conceivedArr)
    // console.log('Age Now Arr', ageNowArr)
    // console.log('Average Age Now', Math.round(averageAgeNow))
    // console.log('Average DOY of Birth', Math.round(averageDOYofBirth))

    this.common.averageDOYofBirth = averageDOYofBirth;
    return averageDOYofBirth;
  }

  // Start Ages (day | months)
  startAges() {
    const years: any = {
      "Cows (>3 years)": 6,
      "Cows (2-3 years)": 2,
      "Heifers (1-2 years)": 1,
      "Steers (1-2 years)": 1,
      "Weaned young heifers": 0,
      "Weaned young steers": 0,
      "Calves weaned this year": 0,
      "Ewes (>2 years)": 4,
      "Ewes (1-2 years)": 1,
      "Wethers (1-2 years)": 1,
      "Weaned young ewes": 0,
      "Weaned young wethers": 0,
      "Lambs weaned this year": 0
    };

    const sd = dayjs(store.state.pasture!.simulation.date).format('D MMM');
    const dy = dayjs(cleanDate(sd, 'D MMM'), 'D MMM').dayOfYear();
    const { averageDOYofBirth } = this.common;

    let startAgeDays: any[] = [];
    this.stocks.forEach((stock) => {
      if (stock.type === "Breeding") {
        startAgeDays.push(
          365 * years[stock.class] + mod(dy - averageDOYofBirth, 365)
        );
      } else {
        if (stock.startAge && stock.startAge > 0) {
          startAgeDays.push((stock.startAge * 365) / 12);
        } else if (stock.purchaseAge && stock.purchaseAge > 0) {
          let ageAtPurchase = ((stock.purchaseAge * 365) / 12) / (365 / 12)
          let purchasePeriod = StartDates.indexOf(dayjs(stock.purchaseDate).format("D MMM")) + 1
          let ageAtStart = ageAtPurchase > 0 ? ageAtPurchase - mod(purchasePeriod - this.periods[0], 24) / 2 : 24
          startAgeDays.push(ageAtStart * (365 / 12));
        } else {
          startAgeDays.push(0);
        }
      }
    });

    let startAgeMonths = startAgeDays.map((sad: any) => {
      return sad / (365 / 12);
    });

    let startAges = {
      days: startAgeDays.map((v:number) => this.trim(v)),
      months: startAgeMonths.map((v:number) => this.trim(v)),
    };

    // TESTS
    // console.log("Start Ages (days): ", startAges.days);
    // console.log("Start Ages (months): ", startAges.months);

    this.common.startAges = startAges;
    return startAges;
  }

  // Ages at midpoint
  agesAtMidpoint() {
    const startAges = this.common.startAges.days;

    let agesAtMidpoint: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let stockAges: any[] = [];
        for (let period = 0; period < 24; period++) {
          let ixPrev = mod(this.periods[mod(period - 1, 24)] - 1, 24);
          let ixCurr = mod(this.periods[mod(period - 1, 24)], 24);
          if (period === 0) {
            stockAges.push(startAges[stockIndex] + 0.5 * PeriodLengths[ixCurr]);
          } else {
            stockAges.push(
              stockAges[period - 1] +
                0.5 * (PeriodLengths[ixPrev] + PeriodLengths[ixCurr])
            );
          }
        }
        agesAtMidpoint.push(stockAges.map((v:number) => this.trim(v)));
      } else {
        agesAtMidpoint.push([]);
      }
    });

    // TESTS
    // console.log('Ages at midpoint: ', agesAtMidpoint)

    this.common.agesAtMidpoint = agesAtMidpoint;
    return agesAtMidpoint;
  }

  // SRW Scalar needed for Liveweights and animalSRW
  srwScalar(this: any, stock: Stock) {
    let srwScalar: number = 1;
    if (stock.type.toLowerCase() === "trading") {
      switch (stock.class.toLowerCase()) {
        case "dry cows or heifers":
        case "dry ewes":
        case "weaned young heifers":
        case "weaned young ewes":
          srwScalar = 1;
          break;
        case "steers":
        case "wethers":
        case "weaned young steers":
        case "weaned young wethers":
          srwScalar = 1.2;
          break;
        case "bulls":
        case "rams":
          srwScalar = 1.4;
          break;
        default:
          srwScalar = 1;
      }
    }
    return srwScalar;
  }

  // Animal SRW (kg)
  animalSRW() {
    let animalSRWs: any[] = [];
    this.stocks.forEach((stock) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        const stockClass = stock.class.toLowerCase();
        const stockType = stock.type.toLowerCase();
        let isFemale = 0;
        let srw = 0;

        isFemale =
          stockClass.includes("cows") ||
          stockClass.includes("heifers") ||
          stockClass.includes("ewes")
            ? 1
            : 0;
        srw = (1.2 - 0.2 * isFemale) * this.livestockWeight;

        if (stockType === "trading") {
          srw = this.livestockWeight * this.srwScalar(stock);
        }

        let animalSRW: any[] = [];
        for (let i = 0; i < 24; i++) {
          animalSRW.push(srw);
        }

        animalSRWs.push(animalSRW);
        // console.log(stockClass + ' - ' + stockType, animalSRW)
      } else {
        animalSRWs.push(new Array(24).fill(0));
      }
    });

    // TEST
    // console.log('Animal SRW', animalSRWs)

    this.common.animalSRW = animalSRWs;
    return animalSRWs;
  }

  // Pasture dW/N
  pastureDwn() {
    // Get the dW/N for the given pastures
    let plocations: any[] = PASTURES.filter(
      (pasture: any) =>
        pasture.LocationID === store.state.pasture!.simulation.location
    );
    let weightings: number[] = [];
    let dwns: any[] = [];
    plocations.map((p: any) => {
      let dwnPeriod: number[] = [];
      for (let i = 1; i <= 24; i++) {
        dwnPeriod.push(this.trim(DWN[this.enterprise][i][PASTURES.indexOf(p)]));
      }
      dwns.push(dwnPeriod);
      weightings.push(PASTURES[PASTURES.indexOf(p)].Weight);
    });

    // Get the dW/N for given location (Lookup tables: dW/N - Cattle | dW/N - Sheep)
    let dwnSumArr: any[] = [];
    for (let i = 0; i < 24; i++) {
      let dwnSum: number = 0;
      let weightingsSum: number = 0;
      dwns.forEach((dwn, dwnIX) => {
        dwnSum += dwn[i] * weightings[dwnIX];
        weightingsSum += weightings[dwnIX];
      });
      dwnSum = dwnSum / weightingsSum;
      dwnSumArr.push(this.trim(dwnSum));
    }

    let dwnResults = {
      dwns: dwns,
      dwnSummary: dwnSumArr,
    };

    // TESTS
    // console.log('Pasture Weighting', weightings)
    // console.log('Pasture dW/N - ' + this.enterprise, dwns)
    // console.log('dW/N Sums - ' + this.enterprise, dwnSumArr)

    this.common.pastureDwn = dwnResults;
    return dwnResults;
  }

  // Default weights for age
  defaultWeightForAge() {
    const averageDOYofBirth = this.common.averageDOYofBirth;
    const dwnSummary = this.common.pastureDwn.dwnSummary;

    // Default weights for age, including LW change pattern (Numbers Etc)
    let defaultWeightForAges: any[] = [];
    let startingPeriod: number = 0;
    let dayOfYear: number = 0;
    while (averageDOYofBirth > dayOfYear) {
      dayOfYear += PeriodLengths[startingPeriod];
      startingPeriod++;
    }
    for (let i = 0; i < 240; i++) {
      let period: number = (startingPeriod + i) % 24;
      period = period === 0 ? 24 : period;
      let wsrw: number =
        i === 0
          ? this.param.BWN
          : defaultWeightForAges[i - 1].wsrw +
            defaultWeightForAges[i - 1].dwsrw * (365 / 24);
      let dwsrw: number =
        this.curvature * (1 - wsrw) + dwnSummary[period - 1] * wsrw;
      defaultWeightForAges.push({
        age: i / 2,
        period: period,
        dwsrw: this.trim(dwsrw),
        wsrw: this.trim(wsrw),
        weightForAge: {
          female: this.trim(this.livestockWeight * wsrw),
          castrate: this.trim(this.livestockWeight * 1.2 * wsrw), // 1.2 srwScalar for steers & wethers
          male: this.trim(this.livestockWeight * 1.4 * wsrw), // 1.4 srwScalar for bulls & rams
        },
      });
    }

    // TESTS
    // console.log('Default weights for age, including LW change pattern', defaultWeightForAges)

    this.common.defaultWeightForAge = defaultWeightForAges;
    return defaultWeightForAges;
  }

  // Default dW (kg/d) & Default dW(kg/period)
  defaultDw() {
    const agesAtMidpoint = this.common.agesAtMidpoint;
    const maxNormalWeight = this.common.maxNormalWeight;
    const dwnSummary = this.common.pastureDwn.dwnSummary;
    const animalSRW = this.common.animalSRW;

    let defaultDWPerDays: any[] = [];
    let defaultDWPeriods: any[] = [];
    this.stocks.forEach((stock, stockIX: number) => {
      let ddwday: any[] = [];
      let ddwperiod: any[] = [];
      if (agesAtMidpoint[stockIX]) {
        for (let i = 0; i < 24; i++) {
          let periodIX =
            mod(this.periods[i], 24) === 0 ? 23 : mod(this.periods[i], 24) - 1;
          ddwday.push(
            this.trim(
              this.curvature *
                (animalSRW[stockIX][i] - maxNormalWeight[stockIX][i]) +
                dwnSummary[periodIX] * maxNormalWeight[stockIX][i]
            )
          );
          ddwperiod.push(this.trim(ddwday[i] * PeriodLengths[periodIX]));
        }
        defaultDWPerDays.push(ddwday);
        defaultDWPeriods.push(ddwperiod);
      }
    });

    let defaultDws = {
      kgDay: defaultDWPerDays,
      kgPeriod: defaultDWPeriods,
    };

    // TESTS
    // console.log('Default dW (kg/d)', defaultDWPerDays)
    // console.log('Default dW (kg/period)', defaultDWPeriods)
    // console.log('Default DWs', defaultDws)

    this.common.defaultDw = defaultDws;
    return defaultDws;
  }

  // Max normal weights (kg) - N(max)
  maxNormalWeight() {
    const animalSRW = this.common.animalSRW;
    const agesAtMidpoint = this.common.agesAtMidpoint;

    let maxNormalWeights: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      if (
        stock.purchaseNumber > 0 ||
        stock.saleNumber > 0 ||
        (stock.startNumber && stock.startNumber > 0)
      ) {
        let mnWeights: number[] = [];
        for (let period = 0; period < 24; period++) {
          mnWeights.push(
            this.trim(
            animalSRW[stockIndex][period] *
              (this.param.BWN +
                (1 - this.param.BWN) *
                  (1 -
                    Math.exp(
                      -this.curvature * agesAtMidpoint[stockIndex][period]
                    )))
            )
          );
        }
        maxNormalWeights.push(mnWeights);
      } else {
        maxNormalWeights.push(new Array(24).fill(0));
      }
    });

    // TEST
    // console.log('Max Normal Weight', maxNormalWeights)

    this.common.maxNormalWeight = maxNormalWeights;
    return maxNormalWeights;
  }

  // Live weights (kg)
  liveWeight() {
    const defaultWeightForAge = this.common.defaultWeightForAge;
    const agesAtMidpoint = this.common.agesAtMidpoint;
    const defaultDwkgPeriod = this.common.defaultDw.kgPeriod;
    const maxNormalWeight = this.common.maxNormalWeight;

    // Default LW (kg)
    let liveWeights: any[] = [];
    this.stocks.forEach((stock, stockIndex: number) => {
      let stockLiveWeight: number[] = [];
      for (let period = 0; period < 24; period++) {
        defaultWeightForAge.map((sw: any) => {
          if (
            agesAtMidpoint[stockIndex] &&
            sw.age === Math.floor((agesAtMidpoint[stockIndex][period] / (365 / 12)) / 0.5) * 0.5
          ) {
            if (period === 0) {
              let weight: number = 0;
              // Use user set start weight
              if (stock.startWeight && stock.startWeight > 0) {
                weight = stock.startWeight;
                // Use default start weight
              } else {
                // Female
                weight = sw.weightForAge.female;
                // Castrated
                if (
                  stock.class.toLowerCase().includes("steers") ||
                  stock.class.toLowerCase().includes("wethers")
                ) {
                  weight = sw.weightForAge.castrate;
                }
                // Male
                if (
                  stock.class.toLowerCase().includes("bulls") ||
                  stock.class.toLowerCase().includes("rams")
                ) {
                  weight = sw.weightForAge.male;
                }
              }
              // Return live weight for first period
              if (stock.type.toLowerCase() === "trading") {
                stockLiveWeight.push(
                  agesAtMidpoint[stockIndex][period] < 0
                    ? maxNormalWeight[stockIndex][period]
                    : weight + 0.5 * defaultDwkgPeriod[stockIndex][period]
                );
              } else {
                stockLiveWeight.push(
                  weight + 0.5 * defaultDwkgPeriod[stockIndex][period]
                );
              }
            } else {
              stockLiveWeight.push(
                this.trim(
                  stockLiveWeight[period - 1] +
                    0.5 *
                      (defaultDwkgPeriod[stockIndex][period - 1] +
                        defaultDwkgPeriod[stockIndex][period])
                )
              );
            }
          }
        });
      }
      liveWeights.push(stockLiveWeight);
    });

    // TESTS
    // console.log("Liveweights", liveWeights);

    this.common.liveWeight = liveWeights.map((i) => {
      if (i.length === 0) return new Array(24).fill(0);
      return i;
    });
    return liveWeights;
  }

  // Suckling join periods
  sucklingJoinPeriod(lessThan2YearsOld?: boolean) {
    const stock = this.getEnterprise.stock;
    const livestock = this.getEnterprise.livestock;

    // Assigns the suckling values for each join period
    let sucklingJoinPeriods: any[] = [];
    for (let jpNum = 0; jpNum < 2; jpNum++) {
      // Sell On - calves / lambs weaned this year sale date period
      let weanedSaleDate: string = stock.filter((s: Stock) => s.class.includes("weaned this year"))[0].saleDate;
      let sellOn = StartDates.indexOf(dayjs(weanedSaleDate).format("D MMM")) + 1;
      // console.log('Sell On', sellOn)

      // Wean On
      let weanOn = StartDates.indexOf(dayjs(livestock.joinPeriods[jpNum].weanDate).format("D MMM")) + 1;
      // console.log('weanOn', weanOn)

      // Weaned at Sale
      // let weanedAtSale: number = mod(sellOn - weanOn, 24);
      // console.log('weanedAtSale', weanedAtSale)

      // Calves / Cow or Lambs / Ewe (Blue Row)
      let periodOfMating: any[] = [];
      let periodOfBirth: any[] = [];
      let youngPerStock: any[] = this.cleanSource(
        this.enterprise === 'cattle'
        ? this.common.conceptionRate["jp" + (jpNum + 1)]
        : this.common.conceptionRate.lambs.survivingRates["jp" + (jpNum + 1)]
      );
      for (let i = 24; i >= 0; i--) {
        let pob = this.periods[0] - i;
        periodOfBirth.push(pob);
        periodOfMating.push(pob - this.gestationPeriods);
      }
      youngPerStock = youngPerStock.map((pas: any, index: number) => {
        let ypsIndex = mod(periodOfMating[index], 24) - 1;
        ypsIndex = ypsIndex !== -1 ? ypsIndex : 23;
        return youngPerStock[ypsIndex];
      });
      // console.log('Period of mating', periodOfMating)
      // console.log('Young Per Stock (blue):', youngPerStock)

      // Young present at start (Red Column)
      let youngPresentAtStart: any[] = this.cleanSource(youngPerStock);
      youngPresentAtStart.forEach((c: number, cIndex: number) => {
        let weanedAtStart: boolean = false;
        weanedAtStart = periodOfBirth[cIndex] < weanOn - (weanOn < this.periods[0] ? 0 : 24);
        // console.log('Weaned at start ' + cIndex, weanedAtStart)
        youngPresentAtStart[cIndex] = weanOn === this.periods[0] || weanedAtStart === true ? 0 : c;
        // Handle none present at start exception for (1-2 years)
        if (lessThan2YearsOld) {
          youngPresentAtStart[cIndex] = 0;
        }
      });
      youngPresentAtStart.reverse();
      // console.log('Young Present At Start (red)', youngPresentAtStart)

      // Generate Suckling Rows
      let sucklingArr: any[] = [];
      for (let calfAge = 0; calfAge < 24; calfAge++) {
        if (calfAge === 0) {
          youngPerStock.unshift(youngPerStock.pop());
          sucklingArr.push(youngPerStock);
        } else {
          let arr: any[] = [];
          for (let period = 0; period < 24; period++) {
            if (period === 0) {
              arr.push(youngPresentAtStart[calfAge]);
            } else {
              if (this.periods[period] === weanOn) {
                arr.push(0);
              } else {
                arr.push(sucklingArr[calfAge - 1][period - 1]);
              }
            }
          }
          sucklingArr.push(arr);
        }
      }
      sucklingJoinPeriods.push(sucklingArr);
    }

    let sucklingTotal: any[] = [];
    sucklingJoinPeriods[0].map((month: any, index: number) => {
      sucklingTotal[index] = [];
      for (let i = 0; i < 24; i++) {
        sucklingTotal[index].push(month[i] + sucklingJoinPeriods[1][index][i]);
      }
    });

    // TESTS
    // console.log('Suckling JP 1', sucklingJoinPeriods[0])
    // console.log('Suckling JP 2', sucklingJoinPeriods[1])
    // console.log('Suckling JPs', sucklingJoinPeriods)
    // console.log('Suckling Total', sucklingTotal)

    // return jp 1, jp2, total and combined jps
    let sucklingJoinPeriodResults = {
      jp1: sucklingJoinPeriods[0],
      jp2: sucklingJoinPeriods[1],
      total: sucklingTotal,
    };

    if (!lessThan2YearsOld) {
      this.common.sucklingJoinPeriod.mature = sucklingJoinPeriodResults;
    } else {
      this.common.sucklingJoinPeriod.young = sucklingJoinPeriodResults;
    }

    return sucklingJoinPeriodResults;
  }

  // Head of stock for each period per class
  headOfStock() {
    let datasets: Dataset[] = [];
    let stockNumbers: any[] = [];
    // Start dates from selected start date - will go into next year
    let revisedStartDates = StartDates.map((sd: string, period: number) => {
      return StartDates[mod(this.periods[period] - 1, 24)];
    });

    this.stocks.forEach((s, stockIndex: number) => {
      let stockNumber: number[] = [];
      for (let period = 0; period < 24; period++) {
        let number = parseInt((s.startNumber || 0).toString());
        if (
          period >=
          revisedStartDates.indexOf(dayjs(s.purchaseDate).format("D MMM"))
        ) {
          number += parseInt(s.purchaseNumber.toString());
        }
        if (
          period >=
          revisedStartDates.indexOf(dayjs(s.saleDate).format("D MMM"))
        ) {
          number -= parseInt(s.saleNumber.toString());
        }
        stockNumber.push(number);
      }
      let color: string = colors[this.enterprise][s.class];
      if (!s.class.includes("weaned this year")) {
        // Merge duplicates
        let mergeData = datasets.filter((ds: any) => ds.label === s.class);
        if (mergeData.length > 0) {
          if (s.class === "Weaned young steers") {
          }
          mergeData[0].data = mergeData[0].data.map((d: any, ix: number) => {
            return d + stockNumber[ix];
          });
        } else {
          // Create unique dataset
          datasets[stockIndex] = {
            label: s.class,
            backgroundColor: color,
            borderColor: 'black', // color,
            borderWidth: 0.5,
            data: stockNumber,
            order: s.type === 'Breeding' ? 0 : 1
          };
        }
      } else {
        datasets[stockIndex] = {
          label: s.class + ' (ignore)',
          data: []
        };
      }
      stockNumbers.push(stockNumber);
    });

    let headOfStock = {
      count: stockNumbers,
      datasets: datasets.filter(ds => ds)
    };

    // TESTS
    // console.log("Head of Stock", stockNumbers);
    // console.log('Head of Stock Datasets', datasets)

    this.common.headOfStock = this.cleanSource(headOfStock);
    return headOfStock;
  }

  // Weaned join periods
  weanedJoinPeriod(jpNum:number, stockClass:string) {
    // Filter to only stock that produces offspring
    let stocks = this.stocks.filter((stock) => stock.class === stockClass)
    let weanedJp:any = Array.from(Array(48), () => Array(24).fill(0))

    stocks.forEach((stock, stockIndex: number) => {
      let suckling = this.common.sucklingJoinPeriod.mature
      if (stock.class.includes("1-2 years")) {
        suckling = this.common.sucklingJoinPeriod.young
      }
      if (!this.getEnterprise.livestock.joinOption && stock.class.includes("2-3 years")) {
        suckling = this.common.sucklingJoinPeriod.young
      }
      let weanPeriod = (1 + AvailableDates.indexOf(AvailableDates.filter(av => av.start === dayjs(this.getEnterprise.livestock.joinPeriods[jpNum - 1].weanDate).format('D MMM'))[0]))

      // Ages: 1 - 24
      suckling['jp' + jpNum].map((stArray: any, period: number) => {
        return stArray.map((stVal: number, age: number) => {
          if (period === 0) {
            weanedJp[period][age] = 0
          } else {
            if (age === 0) {
              if (this.periods[age] !== weanPeriod) {
                weanedJp[period][age] = 0
              } else {
                weanedJp[period][age] = suckling['jp' + jpNum][period - 1][age]
              }
            } else if (age <= 23 && this.periods[age] === weanPeriod) {
              weanedJp[period][age] = suckling['jp' + jpNum][period - 1][age - 1]
            } else {
              weanedJp[period][age] = weanedJp[period - 1][age - 1]
            }
          }
        })
      })

      // Ages: 25 - 48
      weanedJp.map((wjpArray: any, age: number) => {
        return wjpArray.map((stVal: number, period: number) => {
          if (age >= 24) {
            if (period === 0) {
              weanedJp[age][period] = 0
            } else {
              weanedJp[age][period] = weanedJp[age - 1][period - 1]
            }
          }
        })
      })
    })

    if (stockClass.includes("1-2 years") && !this.getEnterprise.livestock.joinOption) {
      weanedJp = weanedJp.map((wjpArray:any[]) => {
        return wjpArray.map((wjpVal:number) => {
          return 0
        })
      })
    }

    return weanedJp
  }

  // Unweaned and weaned young
  weanedData() {
    let datasets: Dataset[] = [];
    const mothers = this.mothers;
    const stockNumbers = this.cleanSource(this.common.headOfStock.count);
    const livestock = this.getEnterprise.livestock;
    const stock = this.getEnterprise.stock;

    // UNWEANED

    let unweanedData: number[] = Array.from(Array(24), () => 0);
    let sumWeanedAtStart: number[] = Array.from(Array(24), () => 0);
    let weanedAtStartMotherJp: any[] = [];
    let offspringUnweanedNDP: any[] = [];

    for (let jpNum = 0; jpNum < livestock.joinNumber; jpNum++) {
      mothers.forEach((mother: any, motherIndex: number) => {
        let numbers =
          stockNumbers[
            Breeds[this.enterprise].classes.breeding.indexOf(mother as never)
          ];
        numbers.unshift(numbers[0]);

        let sucklingJp = this.cleanSource(
          this.common.sucklingJoinPeriod.mature
        )["jp" + (jpNum + 1)];
        let jp = livestock.joinPeriods[jpNum];
        let noneAtStart = false;

        // Handle none present at start exception for (1-2 years)
        if (mother.includes("1-2 years")) {
          noneAtStart = true;
          sucklingJp = (this.cleanSource(this.sucklingJoinPeriod(true)) as any)["jp" + (jpNum + 1)];
        }

        // Handle join option for yearlings
        if (!this.getEnterprise.livestock.joinOption && mother.includes("2-3 years")) {
          noneAtStart = true;
          sucklingJp = (this.cleanSource(this.sucklingJoinPeriod(true)) as any)["jp" + (jpNum + 1)];
        }

        // Sum of suckling periods
        let sucklingJpPeriodSums: number[] = Array.from(Array(24), () => 0);
        for (let period = 0; period < 24; period++) {
          sucklingJp.forEach((array: any) => {
            sucklingJpPeriodSums[period] += array[period];
          });
        }
        // console.log('Suckling Join Period Sums', sucklingJpPeriodSums)

        // Unweaned offspring numbers during period
        // Number of stock for given period * sum of suckling join period
        let unweanedNDP: number[] = Array.from(Array(24), () => 0);
        sucklingJpPeriodSums.map((suckling: number, period: number) => {
          unweanedNDP[period] = numbers[period + 1] * suckling;
        });

        // Offspring numbers during period (start)
        if (!noneAtStart) {
          unweanedNDP.unshift(
            numbers[numbers.length - 1] > 0
              ? (numbers[0] / numbers[numbers.length - 1]) *
                  unweanedNDP[unweanedNDP.length - 1]
              : unweanedNDP[0]
          );
        } else {
          unweanedNDP.unshift(unweanedNDP[0]);
        }
        // console.log((this.enterprise === 'cattle' ? 'Calf' : 'Lamb') + ' unweaned numbers during period', unweanedNDP)
        offspringUnweanedNDP.push(unweanedNDP)

        // Calves / lambs weaned at start of period
        let weanedAtStart: number[] = [];
        for (let period = 0; period < unweanedNDP.length - 1; period++) {
          // Calves / lambs weaned at start of period
          weanedAtStart.push(
            this.trim(
            this.periods[period] ===
              StartDates.indexOf(dayjs(jp.weanDate).format("D MMM")) + 1
              ? unweanedNDP[period]
              : 0
            )
          );
          sumWeanedAtStart[period] += weanedAtStart[period];
        }
        weanedAtStartMotherJp.push(weanedAtStart);
        // console.log((this.enterprise === 'cattle' ? 'Calves' : 'Lambs') + ' weaned at start of period', weanedAtStart)

        // Total unweaned
        unweanedNDP.map((undp: number, period: number) => {
          if (period > 0) {
            unweanedData[period - 1] += undp;
          }
        });
      });
    }
    // console.log('Unweaned', unweanedData)

    // WEANED

    let weanedData: any[] = Array.from(Array(24), () => 0);
    let offspringSoldAtStart: any[] = Array.from(Array(mothers.length * livestock.joinNumber), () => []);
    let offspringWeanedNDP: any[] = Array.from(Array(mothers.length * livestock.joinNumber), () => []);
    let weanedStock = stock.filter((s: any) =>
      s.class.includes("weaned this year")
    )[0];
    let sellOn =
      StartDates.indexOf(dayjs(weanedStock.saleDate).format("D MMM")) + 1;
    let sellNum = weanedStock.saleNumber;
    let count = 0; // index: 0, 1, 2, 3, 4, 5

    // For each period
    for (let period = 0; period < 24; period++) {
      count = 0;
      // For each join
      for (let jpNum = 0; jpNum < livestock.joinNumber; jpNum++) {
        // For each mother
        // Calculate offspring sold at start of period and weaned numbers during period
        mothers.forEach((mother: any, motherIndex: number) => {
          let weanedAtStart = weanedAtStartMotherJp[count][period] || 0;
          let weanedNDP = period === 0 ? 0 : offspringWeanedNDP[count][period - 1];
          let soldAtStart = getSoldAtStart(
            this.periods,
            period,
            weanedAtStart,
            weanedNDP
          );
          offspringSoldAtStart[count].push(soldAtStart);
          offspringWeanedNDP[count].push(
            this.trim(
              Math.max(0, weanedNDP + weanedAtStart - soldAtStart)
            )
          );
          count++;
        });
      }
    }

    // Calculate the number of offspring sold at start of period
    function getSoldAtStart(
      periods: number[],
      currentPeriod: number,
      weanedAtStart: number,
      weanedNDP: number
    ) {
      let combinedSum = 0;
      if (currentPeriod === 0) {
        combinedSum = sumWeanedAtStart[currentPeriod];
      } else {
        let sumWeanedNDP = 0;
        offspringWeanedNDP.map((wa: any) => {
          sumWeanedNDP += wa[currentPeriod - 1];
        });
        combinedSum = sumWeanedAtStart[currentPeriod] + sumWeanedNDP;
      }
      let result = (periods[currentPeriod] === sellOn && weanedNDP + weanedAtStart) > 0
        ? (sellNum * (weanedNDP + weanedAtStart)) / combinedSum
        : 0;
      return result >= 0 ? result : 0
    }

    // Get total weaned number during period
    offspringWeanedNDP.map((wndpArray: any) => {
      wndpArray.map((wndpVal: number, period: number) => {
        weanedData[period] += wndpVal;
      });
    });

    // Add weaned chart dataset
    let weanedLabel: string =
      (this.enterprise === "cattle" ? "Calves" : "Lambs") + " weaned this year";
    let weanedColor: CanvasPattern = colors[this.enterprise][weanedLabel];
    datasets.push({
      label: weanedLabel,
      backgroundColor: weanedColor,
      borderColor: 'black', // weanedColor,
      borderWidth: 0.5,
      data: weanedData.map(v => { return (v < 0 ? 0 : v) })
    });

    // Add unweaned chart dataset
    let unweanedLabel: string =
    this.enterprise === "cattle" ? "Unweaned calves" : "Unweaned lambs";
    let unweanedColor: string = colors[this.enterprise][unweanedLabel];
    datasets.push({
      label: unweanedLabel,
      backgroundColor: unweanedColor,
      borderColor: 'black', // unweanedColor,
      borderWidth: 0.5,
      data: unweanedData.map(v => { return (v < 0 ? 0 : v) })
    });

    // TESTS
    // console.log('Sold at start', offspringSoldAtStart)
    // console.log('Weaned at start of period', weanedAtStartMotherJp)
    // console.log('Weaned numbers during period', offspringWeanedNDP)
    // console.log('Unweaned ' + (this.enterprise === 'cattle' ? 'calves' : 'lambs'), unweanedData)
    // console.log('Weaned ' + (this.enterprise === 'cattle' ? 'calves' : 'lambs'), weanedData)
    // console.log('Unweaned / weaned datasets', datasets)

    let results = {
      mothers: {
        unweaned: {
          start: weanedAtStartMotherJp,
          during: offspringUnweanedNDP
        },
        weaned: {
          during: offspringWeanedNDP
        }
      },
      unweaned: unweanedData,
      weaned: weanedData,
      datasets: datasets
    };

    this.common.weanedData = this.cleanSource(results);
    return results;
  }

  // Get stock start weights
  getStartWeight(stock:Stock, stockIndex:number, ageIndex?:number) {
    const startAges = this.cleanSource(this.common.startAges);
    const defaultWeightForAge = this.cleanSource(this.common.defaultWeightForAge);
    if (stock.startNumber && stock.startNumber > 0) {
      // Start age rounded down to nearest 0.5
      let startAgeRound = Math.floor(startAges.months[stockIndex] / 0.5) * 0.5
      let index = defaultWeightForAge.map((wfa: any) => wfa.age).indexOf(ageIndex || startAgeRound);
      if (index !== -1) {
        // Castrated
        if (stock.class.toLowerCase().includes("steers") || stock.class.toLowerCase().includes("wethers")) {
          return defaultWeightForAge[index].weightForAge.castrate;
        // Male
        } else if (stock.class.toLowerCase().includes("bulls") || stock.class.toLowerCase().includes("rams")) {
          return defaultWeightForAge[index].weightForAge.male;
        // Female (default)
        } else {
          return defaultWeightForAge[index].weightForAge.female;
        }
      } else {
        return 0;
      }
    }
    return 0
  }

  // Update livestock values in table and charts
  updateLivestockValues() {
    const liveWeights = this.cleanSource(this.common.liveWeight);
    const startAges = this.cleanSource(this.common.startAges);
    const weanedData = this.cleanSource(this.common.weanedData)
    const defaultWeightForAge = this.cleanSource(this.common.defaultWeightForAge);
    const readonly = ['Cows (>3 years)', 'Cows (2-3 years)', 'Ewes (>2 years)']
    const simulationStartDate = this.$store.state.pasture.simulation.date

    this.stocks.forEach((stock: Stock, stockIndex: number) => {
      // ----- START -----

      // Start Age
      if (stock.type === "Trading") {
        if (stock.startAge != 0) {
          if (stock.class.toLowerCase().includes('weaned')) {
            if (stock.startAge < 2) {
              stock.startAge = 2
            } else if (stock.startAge > 12) {
              stock.startAge = 12
            }
          } else {
            if (stock.startAge < 10) {
              stock.startAge = 10
            } else if (stock.startAge > 72) {
              stock.startAge = 72
            }
          }
        }
      } else {
        stock.startAge = Math.round(startAges.months[stockIndex]);
      }

      // Start Weight
      if (stock.startNumber && stock.startNumber > 0 && stock.startAge > 0) {
        // If start weight does not exist
        // or start weight is outside valid range
        if (
          (!stock.startWeight || stock.startWeight <= 0) ||
          ((stock.startWeight && stock.defaultStartWeight) && stock.startWeight < stock.defaultStartWeight * 0.6) ||
          ((stock.startWeight && stock.defaultStartWeight) && stock.startWeight > stock.defaultStartWeight * 1.4)
        ) {
          stock.startWeight = this.getStartWeight(stock, stockIndex)
          stock.defaultStartWeight = stock.startWeight
        // else if startWeight exists
        } else {
          //if (stock.type === "Trading") {
            stock.defaultStartWeight = this.getStartWeight(stock, stockIndex, stock.startAge)
          //}
        }
      } else {
        stock.startWeight = 0
      }

      // ----- PURCHASES -----

      // Purchase Age
      if (stock.type === "Trading") {
        if (stock.purchaseAge != 0) {
          if (stock.class.toLowerCase().includes('weaned')) {
            if (stock.purchaseAge < 2) {
              stock.purchaseAge = 2
            } else if (stock.purchaseAge > 12) {
              stock.purchaseAge = 12
            }
          } else {
            if (stock.purchaseAge < 10) {
              stock.purchaseAge = 10
            } else if (stock.purchaseAge > 72) {
              stock.purchaseAge = 72
            }
          }
        }
      } else if (stock.type === "Breeding") {
        stock.purchaseAge = Math.floor(
          stock.startAge +
            mod(
              dayjs(stock.purchaseDate).dayOfYear() -
                dayjs(simulationStartDate).dayOfYear(),
              365
            ) /
            (365 / 12)
        );
      }

      // Purchase weight
      if ((stock.purchaseNumber && stock.purchaseNumber > 0)) {
        let liveWeightPurchaseIndex = (
          StartDates.indexOf(dayjs(stock.purchaseDate).format("D MMM")) -
          StartDates.indexOf(dayjs(simulationStartDate).format("D MMM"))
        );
        // If purchase weight does not exist
        // or purchase weight is outside valid range
        // or class in readonly
        if (
          (!stock.purchaseWeight || stock.purchaseWeight <= 0) ||
          ((stock.purchaseWeight && stock.defaultPurchaseWeight) && stock.purchaseWeight < stock.defaultPurchaseWeight * 0.6) ||
          ((stock.purchaseWeight && stock.defaultPurchaseWeight) && stock.purchaseWeight > stock.defaultPurchaseWeight * 1.4) ||
          readonly.indexOf(stock.class) >= 0
        ) {
          // Update stock purchase weight and default stock purchase weight
          stock.purchaseWeight = liveWeights[stockIndex][mod(liveWeightPurchaseIndex, 24)] || 0;
          stock.defaultPurchaseWeight = stock.purchaseWeight
        // else if purchase weight exists
        } else {
          // Update default stock purchase weight only
          stock.defaultPurchaseWeight = liveWeights[stockIndex][mod(liveWeightPurchaseIndex, 24)] || 0;
        }
      // If sale number is less than or equal to 0
      } else {
        if (readonly.indexOf(stock.class) < 0) {
          stock.purchaseWeight = 0
        }
      }

      // ----- SALES -----

      // Sale Age
      let age = 0
      let startDate = simulationStartDate
      if (stock.type === 'Trading') {
        if (stock.startAge && stock.startAge > 0) {
          age = stock.startAge
        } else if (stock.purchaseAge && stock.purchaseAge > 0) {
          age = stock.purchaseAge
          startDate = stock.purchaseDate
        }
      } else {
        age = stock.startAge
      }
      stock.saleAge = Math.round(
        age +
          mod(
            dayjs(stock.saleDate).dayOfYear() -
              dayjs(startDate).dayOfYear(),
            365
          ) /
          (365 / 12)
      );

      // Sale Weight
      if ((stock.saleNumber && stock.saleNumber > 0)) {
        let liveWeightSaleIndex = (
          StartDates.indexOf(dayjs(stock.saleDate).format("D MMM")) -
          StartDates.indexOf(dayjs(simulationStartDate).format("D MMM"))
        );
        // If sale weight does not exist
        // or sale weight is outside valid range
        // or class in readonly
        if (
          (!stock.saleWeight || stock.saleWeight <= 0) ||
          ((stock.saleWeight && stock.defaultSaleWeight) && stock.saleWeight < stock.defaultSaleWeight * 0.6) ||
          ((stock.saleWeight && stock.defaultSaleWeight) && stock.saleWeight > stock.defaultSaleWeight * 1.4) ||
          readonly.indexOf(stock.class) >= 0
        ) {
          // Update stock sale weight and default stock sale weight
          stock.saleWeight = liveWeights[stockIndex][mod(liveWeightSaleIndex, 24)] || 0;
          if (stock.class.includes("weaned this year")) {
            // The average weight between a castrate and female
            stock.saleWeight = (
              defaultWeightForAge[(stock.saleAge - 0.5) * 2].weightForAge.castrate +
              defaultWeightForAge[(stock.saleAge - 0.5) * 2].weightForAge.female
            ) / 2
          }
          stock.defaultSaleWeight = stock.saleWeight
        // else if sale weight exists
        } else {
          // Update default stock sale weight only
          stock.defaultSaleWeight = liveWeights[stockIndex][mod(liveWeightSaleIndex, 24)] || 0;
        }
      // If sale number is less than or equal to 0
      } else {
        if (readonly.indexOf(stock.class) < 0) {
          stock.saleWeight = 0
        }
      }

      // Number available for sale
      if (stock.startNumber) {
        stock.saleAvailable = stock.startNumber + (dayjs(stock.purchaseDate).isBefore(stock.saleDate) ? stock.purchaseNumber : 0)
      } else if (stock.purchaseNumber) {
        stock.saleAvailable = (dayjs(stock.purchaseDate).isBefore(stock.saleDate) ? stock.purchaseNumber : 0)
      } else {
        stock.saleAvailable = 0
      }
      // If sale number is greater than sale available
      if (stock.saleNumber > stock.saleAvailable) {
        stock.saleNumber = stock.saleAvailable || 0
      }

      // Start Number & Weight for weaned this year
      if (stock.class.includes("weaned this year")) {
        let weanPeriod = StartDates.indexOf(dayjs(this.getEnterprise.livestock.joinPeriods[0].weanDate).format("D MMM")) + 1;
        let startPeriod = this.periods[0];
        stock.startNumber =
          weanPeriod === startPeriod
            ? Math.round(weanedData.weaned[0])
            : Math.round(weanedData.unweaned[0]);
        stock.startWeight = null;
      }
    });
  } 
}
